import React from 'react';

const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "E-commerce App",
      description: "Aplicación de comercio electrónico con React y Node.js",
      url: "https://github.com/usuario/ecommerce-app"
    },
    {
      id: 2,
      title: "Dashboard Analytics",
      description: "Panel de control con visualización de datos",
      url: "https://github.com/usuario/dashboard-analytics"
    },
    {
      id: 3,
      title: "Landing Page",
      description: "Página de aterrizaje responsive para startup",
      url: "https://github.com/usuario/landing-page"
    },
    {
      id: 4,
      title: "Mobile App UI",
      description: "Diseño de interfaz para aplicación móvil",
      url: "https://dribbble.com/usuario/mobile-app"
    }
  ];

  const handleProjectClick = (url) => {
    window.open(url, '_blank');
  };

  return (
    <section id="proyectos" className="projects">
      <div className="container">
        <h2>Mis Proyectos</h2>
        <div className="projects-grid">
          {projects.map(project => (
            <div 
              key={project.id} 
              className="project-card"
              onClick={() => handleProjectClick(project.url)}
            >
              <div className="project-image">
                Imagen del Proyecto
              </div>
              <div className="project-content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;